<template>
    <el-row>
        <table-template :queryParams="queryParams" actionUrl="/businessKeyWord/findBusinessKeyWordList.action"
                        ref="Table">
            <template slot="search">
                <el-row>
                    <el-form :inline="true" class="demo-form-inline">
                        <el-form-item>
                            <el-select v-model="queryParams.type"  @change="$refs.Table.search()" placeholder="关键词类型" :clearable="true" :filterable="true">
                                <el-option :value="1" label="黑名单"></el-option>
                                <el-option :value="2" label="白名单"></el-option>
                            </el-select>
                        </el-form-item>
                      <el-form-item>
                        <el-input placeholder="搜索关键词" v-model="queryParams.content"></el-input>
                      </el-form-item>
                        <el-form-item>
                            <el-button @click="$refs.Table.search()" type="primary">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="$router.push({path:'/home/saveBusinessKeyword'})">新增关键词</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>

            </template>
            <template slot="item">
                <el-table-column
                        label="关键词"
                        prop="content">
                </el-table-column>

                <el-table-column
                        label="类型"
                        prop="ype">
                    <template scope="scope">
                        {{ scope.row.type|targetFilter }}
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" width="300">
                    <template scope="scope">
                        <span style="margin-left: 10px;color:#909399;">{{scope.row.createTime|dateTimeFormat }}</span>
                    </template>
                </el-table-column>

                <el-table-column
                        label="操作" width="250px">
                    <template scope="scope" >
                        <el-button :type="success"  size="small"  v-confirm  requestUrl="businessKeyWord/deleteKeyWord.action" :confirm-data="{id:scope.row.id}" @onConfirm="$refs.Table.search()">删除</el-button>
                        <el-button type="warning"  size="small"  @click="$router.push({name:'编辑关键词', params: { id: scope.row.id }})" >编辑 </el-button>
                    </template>
                </el-table-column>
            </template>
        </table-template>
    </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'business-key-word',
  data: function () {
    return {
      queryParams: {type:null,content:null}
    }
  },
  methods: {

  },
  filters: {
    targetFilter: function (val) {
      let str = '非法值'
      switch (val) {
        case 1:
          str = '黑名单'
          break
        case 2:
          str = '白名单'
          break

      }
      return str
    }
  }
}
</script>

<style scoped>
</style>
